// Import Actions
import { SET_PRODUCTS, SET_PRODUCT_SPECIAL_PRICE } from './ProductActions.js';
import { LOGOUT_USER } from '../User/UserActions.js';

// Initial State
export const initialState = {
    data: [],
};

const ProductReducer = (state = initialState, action = {}) => {
    switch(action.type) {
        case SET_PRODUCTS:
            return {
                ...state,
                data: state.data
					.filter(existingProduct => !action.products.find(product => product._id === existingProduct._id))
					.concat(action.products.map(product => {
						if(action.applyExtraSpecialPrices) {
							return {
								...product,
								specialPrices: [
									...((state.data.find(p => product._id === p._id) || {}).specialPrices || []).filter(specialPrice => specialPrice.isReferralExtra),
									...product.specialPrices,
								],
							};
						}
						return product;
					})),
            };

		case SET_PRODUCT_SPECIAL_PRICE:
			return {
				...state,
				data: state.data.map(product => {
					if(product._id === action.productId) {
						return {
							...product,
							specialPrices: [{ ...action.specialPrice, isReferralExtra: true }, ...(product.specialPrices || [])],
						};
					}
					return product;
				}),
			};

        case LOGOUT_USER:
            // return initialState;
            return state;

        default:
            return state;
    }
};

export default ProductReducer;
